import React from 'react';

export const Eye = ({ color }) => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.8962 5.64255C15.2715 2.82952 12.246 1.08203 9 1.08203C5.75401 1.08203 2.72853 2.82952 1.10377 5.64255C0.96541 5.88197 0.96541 6.17733 1.10377 6.41675C2.72853 9.22978 5.75401 10.9773 9 10.9773C12.246 10.9773 15.2715 9.22978 16.8962 6.41675C17.0346 6.17733 17.0346 5.88197 16.8962 5.64255ZM9 9.42887C6.45764 9.42887 4.07784 8.13728 2.68417 6.02965C4.07784 3.92202 6.45764 2.63043 9 2.63043C11.5424 2.63043 13.9222 3.92202 15.3158 6.02965C13.9222 8.13728 11.5424 9.42887 9 9.42887Z"
        fill={color || 'url(#paint0_linear_2494_115293)'}
      />
      <path
        d="M9 3.1632C7.41934 3.1632 6.13355 4.44899 6.13355 6.02965C6.13355 7.61031 7.41934 8.89611 9 8.89611C10.5807 8.89611 11.8665 7.61031 11.8665 6.02965C11.8665 4.44899 10.5807 3.1632 9 3.1632ZM9 7.34771C8.27318 7.34771 7.68195 6.75647 7.68195 6.02965C7.68195 5.30283 8.27318 4.7116 9 4.7116C9.72682 4.7116 10.3181 5.30283 10.3181 6.02965C10.3181 6.75647 9.72682 7.34771 9 7.34771Z"
        fill={color || 'url(#paint1_linear_2494_115293)'}
      />
      <path
        d="M16.8962 5.64255C15.2715 2.82952 12.246 1.08203 9 1.08203C5.75401 1.08203 2.72853 2.82952 1.10377 5.64255C0.96541 5.88197 0.96541 6.17733 1.10377 6.41675C2.72853 9.22978 5.75401 10.9773 9 10.9773C12.246 10.9773 15.2715 9.22978 16.8962 6.41675C17.0346 6.17733 17.0346 5.88197 16.8962 5.64255ZM9 9.42887C6.45764 9.42887 4.07784 8.13728 2.68417 6.02965C4.07784 3.92202 6.45764 2.63043 9 2.63043C11.5424 2.63043 13.9222 3.92202 15.3158 6.02965C13.9222 8.13728 11.5424 9.42887 9 9.42887Z"
        stroke={color || 'url(#paint2_linear_2494_115293)'}
        stroke-width="0.25"
      />
      <path
        d="M9 3.1632C7.41934 3.1632 6.13355 4.44899 6.13355 6.02965C6.13355 7.61031 7.41934 8.89611 9 8.89611C10.5807 8.89611 11.8665 7.61031 11.8665 6.02965C11.8665 4.44899 10.5807 3.1632 9 3.1632ZM9 7.34771C8.27318 7.34771 7.68195 6.75647 7.68195 6.02965C7.68195 5.30283 8.27318 4.7116 9 4.7116C9.72682 4.7116 10.3181 5.30283 10.3181 6.02965C10.3181 6.75647 9.72682 7.34771 9 7.34771Z"
        stroke={color || 'url(#paint3_linear_2494_115293)'}
        stroke-width="0.25"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2494_115293"
          x1="1"
          y1="6.02965"
          x2="17"
          y2="6.02965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EE318A" />
          <stop offset="1" stop-color="#EC6551" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2494_115293"
          x1="1"
          y1="6.02965"
          x2="17"
          y2="6.02965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EE318A" />
          <stop offset="1" stop-color="#EC6551" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2494_115293"
          x1="1"
          y1="6.02965"
          x2="17"
          y2="6.02965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EE318A" />
          <stop offset="1" stop-color="#EC6551" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2494_115293"
          x1="1"
          y1="6.02965"
          x2="17"
          y2="6.02965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EE318A" />
          <stop offset="1" stop-color="#EC6551" />
        </linearGradient>
      </defs>
    </svg>
  );
};
